module.exports = __webpack_public_path__ + "img/pay-tmp-normal.6fb7966a.png";